import Global from "./containers/Global";
import ModelPage from "./containers/ModelPage";
import Offers from "./containers/Offers";
import Forms from "./containers/Forms";
import BrochureDownload from "./containers/BrochureDownload";
import RegisterYourInterest from "./containers/RegisterYourInterest";
import HybridPreorder from "./containers/HybridPreorder";

require("../sass/main.scss");

ModelPage();
Offers();
Forms();
BrochureDownload();
RegisterYourInterest();
HybridPreorder();

Global(); //Should be last
